export interface ISavePortfolioRequestProps {
  id: number;
  symbol: string;
  quantity: number;
  expiry: string;
  strike: number;
  legType: string;
  costBasisTotal: number;
  markedAsDeleted: boolean;
  enableExpiry?: boolean;
  enablestrikePrice?: boolean;
  isNew: boolean;
  tag: string;
  premiumMultiplier: number;
}

export interface ISavePortfolioRequest {
  totalRecords: number;
  portfolioId: number;
  portfolioName: string;
  isManualSelection: boolean;
  portfolioPositions?: ISavePortfolioRequestProps[];
}

export class SavePortfolioRequest implements ISavePortfolioRequest {
  portfolioPositions = [
    {
      id: 0,
      symbol: '',
      quantity: 0,
      expiry: '',
      strike: 0,
      legType: '',
      costBasisTotal: 0,
      markedAsDeleted: false,
      enableExpiry: true,
      enablestrikePrice: true,
      isNew: true,
      tag: '',
      premiumMultiplier: 100,
    },
  ];
  totalRecords = 0;
  isManualSelection = true;
  portfolioId = 0;
  portfolioName = '';

  public static fromJson = (items: SavePortfolioRequest): SavePortfolioRequest => {
    const model = new SavePortfolioRequest();
    model.totalRecords = items.totalRecords;
    model.portfolioId = items.portfolioId;
    model.portfolioName = items.portfolioName;
    model.isManualSelection = items.isManualSelection;
    model.portfolioPositions = items.portfolioPositions;
    return model;
  };
}
